import { useRef, useState, useEffect } from "react";

import { Button, Grid, Paper, TablePagination, Typography } from '@material-ui/core';
import moment from "moment";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import TableGeneric from "../../compartidos/abms/TableGeneric";
import { DatePickerGeneric } from "../../atomic/atoms/DatePicker";
import { useSurge } from "../../../hooks/useCases/useSurge";
import IconEstado from "../../autorizaciones/UI/IconEstado";
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import RateReviewIcon from '@material-ui/icons/RateReview';
import { GenericModal } from "../../atomic/organisms/GenericModal";
import { IconButtonGeneric } from "../../atomic/atoms/Buttons";
import { History, Save, Edit, AttachMoney, ArrowBackIos } from '@material-ui/icons';
import { useFormNew } from "../../../hooks/useFormNew";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { useDispatch } from "react-redux";
import { startAlerta } from "../../../actions/ui/alertas";
import { RadioGroupGeneric } from "../../atomic/molecules/RadioGroupGeneric";
import ToolbarXLSPDF from "../../compartidos/ToolbarXLSPDF";
import Buscador from "../../../actions/ui/Buscador";
import DeleteButtonAbm from "../../compartidos/abms/DeleteButtonAbm";
import { SolicitudForm } from "./SolicitudForm";

const center = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
};

const initModalEstados = {
  open: false,
  title: '',
  solicitud: {}
};

const initModalTracking = {
  open: false,
  title: '',
  idEstado: null
};

const initModalEditar = {
  open: false,
  title: '',
  solicitud: null
};

const fechaActual = new Date();

export const GestionSolicitudes = () => {
  const componentRef = useRef();
  const surge = useSurge();
  const dispatch = useDispatch()

  useEffect(() => {
    surge.get.all.estadosSolicitudes()
  }, [])

  const [afiliado, setAfiliado] = useState(null);
  const [solicitud, setSolicitud] = useState(null);
  const [search, setSearch] = useState({
    fechaDesde: moment().format(),
    fechaHasta: moment().format(),
    idEstado: surge.data.estados[0].id,
  });

  const handleSearch = (page, pageSize) => {
    surge.get.byParameters.solicitudesConPaginado({
      fechaDesde: moment(search.fechaDesde).startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
      fechaHasta: moment(search.fechaHasta).endOf('day').format('YYYY-MM-DDTHH:mm:ss'),
      idEstado: search.idEstado,
      page,
      pageSize,
      idAfiliado: afiliado?.id_afiliado ?? null,
      idSolicitud: solicitud?.id ?? null
    });
  }
  const [estado, setEstado] = useState("");
  const [modalEstados, setModalEstados] = useState(initModalEstados);
  const [modalTracking, setModalTracking] = useState(initModalTracking);
  const [modalEditar, setModalEditar] = useState(initModalEditar);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const dataDates = [
    { value: search.fechaDesde, onChange: (date) => { setSearch({ ...search, fechaDesde: date }) }, label: "Fecha Desde" },
    { value: search.fechaHasta, onChange: (date) => { setSearch({ ...search, fechaHasta: date }) }, label: "Fecha Hasta" },
  ];

  const initialState = {
    nroSolicitud: null,
    expediente: null,
    importeReconocido: null,
    fecha: null,
    observaciones: null
  };

  const { formValues, handleInputChange, setearValor, setFormValues, reset } = useFormNew(initialState);

  const onSubmit = (e) => {
    e.preventDefault();
    if (estado === "")
      return dispatch(startAlerta("Seleccione una acción", "error", "Error"))
    else if (estado === "APROBAR SOLICITUD")
      surge.update.aprobarSolicitud({ ...formValues, idEstado: surge.data.estados.find((estado) => estado.descripcion === "Solicitudes").id }, () => handleSearch())
    else if (estado === "RECHAZAR SOLICITUD")
      surge.update.rechazarSolicitud({ ...formValues, idEstado: surge.data.estados.find((estado) => estado.descripcion === "Rechazadas").id }, () => handleSearch())
    else if (estado === "NOTIFICACION SOLICITUD")
      surge.update.notificacionSolicitud({ ...formValues, idEstado: surge.data.estados.find((estado) => estado.descripcion === "Notificaciones").id }, () => handleSearch())
    else if (estado === "PAGAR SOLICITUD")
      surge.update.pagarSolicitud({ ...formValues, idEstado: surge.data.estados.find((estado) => estado.descripcion === "Pagadas").id }, () => handleSearch())
    reset(initialState)
    setModalEstados(initModalEstados);
    setEstado("")
  }

  useEffect(() => handleSearch(page, rowsPerPage), [search, afiliado, solicitud]);

  const handleChangePage = (event, newPage) => {
    handleSearch(newPage + 1, surge.data.paginacion.pageSize, false);
    window.scrollTo(0, 0)
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    handleSearch(surge.data.paginacion.currentPage, parseInt(event.target.value, 10), false);
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      <Grid spacing={2} container justify='center'>
        <Grid
          item
          xs={12}
          component={Paper}
          elevation={1}
          style={{ padding: 0 }}
        >
          <Grid container alignItems='center'>
            <Grid item xs={5}>
              <Grid
                container
                justify="space-evenly"
                style={{ backgroundColor: '#eee' }}
              >
                {dataDates.map(({ value, onChange, label }, index) => (
                  <Grid key={index} item xs={12} md={6} style={{ ...center, backgroundColor: "#FFF", border: "1px solid #ccc", padding: "0.5em" }}>
                    <DatePickerGeneric
                      style={{ padding: "0 0.5em" }}
                      value={value}
                      label={label}
                      onChange={(e) => { if (moment(e).isValid()) onChange(e) }}
                      fullWidth
                      disabled={solicitud}
                      {...(index === 0) ? { maxDate: search.fechaHasta } : { minDate: search.fechaDesde }}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
            <Grid item xs={4}>
              <Grid
                container
                spacing={1}
                alignItems="center"
                justify="space-evenly"
                style={{ padding: "1em" }}
              >
                <Buscador
                  value={afiliado}
                  variant="outlined"
                  setValue={(afiliado) => afiliado !== null ? setAfiliado(afiliado) : setAfiliado(null)}
                  label="Apellido y Nombre | Nro Doc | Nro Afiliado | CUIL"
                  endpoint={(texto) => `Afiliados/traerPorNombreoDNIoNroAfi/${texto}/Todos/Todos`}
                  noOptionText={"No se encuentra afiliado"}
                  fieldsDisabled={solicitud}
                  getOptionLabel={(option) => (`${option.apellido_y_nombre} - ${option.carnet}`)}
                  renderOption={(option) => (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <span style={{ color: option.fecha_baja === null || option.fecha_baja >= fechaActual.toISOString() ? "green" : "red" }}>
                        {`${option.apellido_y_nombre} - DNI: ${option.nro_doc} ${`- CARNET: ${option.carnet}`}`}
                      </span>
                    </div>
                  )}
                />
              </Grid>

            </Grid>
            <Grid item xs={3}>
              <Buscador
                value={solicitud}
                variant="outlined"
                setValue={(solicitud) => solicitud !== null ? setSolicitud(solicitud) : setSolicitud(null)}
                label="N° Solicitud"
                endpoint={(texto) => { if (texto.length > 3) return `SolicitudesSSS/SearchPorNroSolicitud/${texto}`}}
                noOptionText={"No se encuentra solicitud"}
                getOptionLabel={(option) => (`${option.apellido_nombre ?? "COLECTIVA"} - ${option.nro_solicitud}`)}
                renderOption={(option) => (
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span style={{ color: "green" }}>
                      {`${option.apellido_nombre ?? "COLECTIVA"} - ${option.nro_solicitud}`}
                    </span>
                  </div>
                )}
              />
            </Grid>
            <Grid item xs={12} md={10} style={{ padding: '0.5em' }}>
              <RadioGroupGeneric
                radioList={surge.data.estados.map((item) => {
                  let cantidadSolicitudes;
                  switch (item.id) {
                    case surge.data.estados.find((estado) => estado.descripcion === 'Solicitudes').id:
                      cantidadSolicitudes = ` (${surge.data.contadorSolicitudes.subidas})`;
                      break;
                    case surge.data.estados.find((estado) => estado.descripcion === 'Notificaciones').id:
                      cantidadSolicitudes = ` (${surge.data.contadorSolicitudes.notificacion})`;
                      break;
                    case surge.data.estados.find((estado) => estado.descripcion === 'Aprobadas').id:
                      cantidadSolicitudes = ` (${surge.data.contadorSolicitudes.aprobadas})`;
                      break;
                    case surge.data.estados.find((estado) => estado.descripcion === 'Rechazadas').id:
                      cantidadSolicitudes = ` (${surge.data.contadorSolicitudes.rechazadas})`;
                      break;
                    case surge.data.estados.find((estado) => estado.descripcion === 'Pagadas').id:
                      cantidadSolicitudes = ` (${surge.data.contadorSolicitudes.pagadas})`;
                      break;
                    default:
                      cantidadSolicitudes = "";
                  }
                  return {
                    value: item.id,
                    label: item.descripcion + cantidadSolicitudes
                  }
                })}
                onChange={(value) => {
                  setSearch({
                    ...search,
                    idEstado: +value,
                  });
                }}
                actualValue={search.idEstado}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <ToolbarXLSPDF
                handleExportExcel={() => {
                  surge.data.solicitudes.length !== 0 ?
                    surge.files.solicitudesSSS.excel({
                      fechaDesde: moment(search.fechaDesde).startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
                      fechaHasta: moment(search.fechaHasta).endOf('day').format('YYYY-MM-DDTHH:mm:ss'),
                      idEstado: search.idEstado,
                      ...(afiliado?.id_afiliado ? {idAfiliado: afiliado?.id_afiliado} : {}),
                      ...(solicitud?.id ? {idSolicitud: solicitud?.id} : {})
                    }) : dispatch(startAlerta("No hay registros para descargar", "error", "Error"))
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <TableGeneric
          ref={componentRef}
          data={surge.data.solicitudes ?? []}
          align="center"
          withoutPagination
          columns={[
            {
              label: 'Historial',
              customBody: (item) => (
                <IconButtonGeneric
                  ariaLabel="historial"
                  Icon={History}
                  color="primary"
                  onClick={() => {
                    surge.get.byId.trackingSolicitud(item.id);
                    setModalTracking({
                      open: true,
                      title: `Historial Solicitud Número ${item.nroSolicitud}`,
                    });
                  }}
                />
              )
            },
            {
              label: 'Estado',
              customBody: (item) => {
                const estadoEncontrado = surge.data.estados.find(
                  (estado) => estado.id === item.idEstado,
                );
                return (
                  <>
                    {estadoEncontrado && (
                      <IconEstado
                        useColorTable
                        texto={estadoEncontrado.letra}
                        backgroundColor={estadoEncontrado.color}
                        descripcion={estadoEncontrado.descripcion}
                      />
                    )}
                  </>
                );
              },
            },
            {
              label: 'N° Solicitud',
              id: 'nroSolicitud',
            },
            ...(search.idEstado === surge.data.estados.find((estado) => estado.descripcion === "Pagadas").id ||
              search.idEstado === surge.data.estados.find((estado) => estado.descripcion === "Aprobadas").id
            ) ?
              [{
                label: 'Expediente',
                customBody: (item) => item.expediente ? item.expediente : "-"
              }] : [],
            {
              label: 'Fecha de envío',
              customBody: (item) => moment(item.fechaEnvio).format("DD/MM/YYYY")
            },
            {
              label: 'Periodo Desde',
              customBody: (item) => item.periodoDesde ? moment(item.periodoDesde).format("DD/MM/YYYY") : "-"
            },
            {
              label: 'Periodo Hasta',
              customBody: (item) => item.periodoHasta ? moment(item.periodoHasta).format("DD/MM/YYYY") : "-"
            },
            {
              label: 'Patología',
              customBody: (item) => item.patologia?.descripcion
            },
            {
              label: 'Afiliado',
              customBody: (item) => item.afiliado ? item.afiliado.apellido_y_nombre : "NO POSEE - COLECTIVA",
            },
            {
              label: 'CUIL',
              customBody: (item) => item.afiliado ? item.afiliado.cuil : "NO POSEE - COLECTIVA",
            },
            {
              label: 'Observación',
              customBody: (item) => item.observaciones !== "" ? item.observaciones : "-",
            },
            {
              label: 'Editar',
              customBody: (item) => (<IconButtonGeneric
                Icon={Edit}
                color="secondary"
                onClick={() => {
                  setModalEditar({
                    open: true,
                    title: `Editar Solicitud - ${item.afiliado ? item.afiliado.apellido_y_nombre : "COLECTIVA"}`,
                    solicitud: item
                  })
                }}
              />)
            },
            ...(search.idEstado === surge.data.estados.find((estado) => estado.descripcion === "Solicitudes").id ||
              search.idEstado === surge.data.estados.find((estado) => estado.descripcion === "Aprobadas").id ?
              [{
                label: 'Cambiar Estado',
                customBody: (item) => (<IconButtonGeneric
                  Icon={RateReviewIcon}
                  color="primary"
                  onClick={() => {
                    setearValor("nroSolicitud", item.nroSolicitud)
                    setModalEstados({
                      open: true,
                      title: `Cambiar estado de solicitud Número ${item.nroSolicitud}`,
                      solicitud: item
                    })
                  }}
                />)
              }]
              : []
            ),
            {
              label: '',
              customBody: (item) => <DeleteButtonAbm
                permiso={null}
                mensajeEliminacion={"¿Desea eliminar esta solicitud?"}
                handleDelete={() => surge.remove.solicitud(item.id)}
              />
            }
          ]}
        />
        <Grid item xs={12}>
          <TablePagination
            style={{ backgroundColor: "white" }}
            rowsPerPageOptions={[10, 15, 20, 25, 50]}
            component="div"
            count={surge.data.paginacion.rowCount || 0}
            rowsPerPage={surge.data.paginacion.pageSize || 0}
            labelRowsPerPage="Registros por página"
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </Grid>
      </Grid>
      {
        modalEstados.open && (
          <GenericModal
            open={modalEstados}
            closeModal={() => {
              reset(initialState)
              setModalEstados(initModalEstados);
              setEstado("")
            }}
            title={modalEstados.title}
            gridStyle={{ textAlign: 'center' }}
            maxWidth="sm"
          >
            <TableGeneric
              ref={componentRef}
              data={[modalEstados.solicitud]}
              align="center"
              colTitleStyle={{ fontSize: '1.2em' }}
              withoutPagination
              columns={[
                ...(search.idEstado === surge.data.estados.find((estado) => estado.descripcion === "Solicitudes").id ?
                  [{
                    label: 'Aprobar Solic.',
                    customBody: () => (<IconButtonGeneric
                      Icon={CheckCircleOutlineIcon}
                      color="primary"
                      onClick={() => {
                        setEstado("APROBAR SOLICITUD")
                        setFormValues({
                          fecha: new Date(),
                          expediente: null,
                          importeReconocido: null,
                          observaciones: null
                        })
                      }}
                    />)
                  },
                  {
                    label: 'Rechazar Solic.',
                    customBody: () => (<IconButtonGeneric
                      Icon={CancelIcon}
                      color="primary"
                      onClick={() => {
                        setEstado("RECHAZAR SOLICITUD")
                        setFormValues({
                          fecha: new Date(),
                          expediente: null,
                          importeReconocido: null,
                          observaciones: null
                        })
                      }}
                    />)
                  },
                  {
                    label: 'Notificación',
                    customBody: () => (<IconButtonGeneric
                      Icon={Edit}
                      color="primary"
                      onClick={() => {
                        setEstado("NOTIFICACION SOLICITUD")
                        setFormValues({
                          fecha: new Date(),
                          expediente: null,
                          importeReconocido: null,
                          observaciones: null
                        })
                      }}
                    />)
                  }]
                  : []
                ),
                ...(search.idEstado === surge.data.estados.find((estado) => estado.descripcion === "Aprobadas").id ?
                  [{
                    label: 'Pagar',
                    customBody: () => (<IconButtonGeneric
                      ariaLabel="historial"
                      Icon={AttachMoney}
                      color="primary"
                      onClick={() => {
                        setEstado("PAGAR SOLICITUD")
                        setFormValues({
                          fecha: new Date(),
                          expediente: null,
                          importeReconocido: null,
                          observaciones: null
                        })
                      }}
                    />)
                  }]
                  : []
                ),
              ]}
            />
            <ValidatorForm onSubmit={onSubmit}>
              <Grid container spacing={2} justify="center">
                <Grid style={{ marginLeft: '1rem', marginTop: '2rem' }} item xs={12}>
                  <Typography
                  >
                    {estado !== "" ? `${estado} ${modalEstados.solicitud.afiliado ? 'PARA ' + modalEstados.solicitud.afiliado.apellido_y_nombre : 'COLECTIVA'}` : ""}
                  </Typography>
                </Grid>
                {
                  (estado !== "") && (
                    <Grid item xs={4} >
                      <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          fullWidth
                          margin="normal"
                          label={
                            (estado === "APROBAR SOLICITUD") ? "Fecha de aprobación" :
                              (estado === "RECHAZAR SOLICITUD") ? "Fecha de rechazo" :
                                (estado === "NOTIFICACION SOLICITUD") ? "Fecha de notificación" :
                                  "Fecha de pago"
                          }
                          format="dd/MM/yyyy"
                          okLabel="Aceptar"
                          maxDate={new Date(moment().format())}
                          clearLabel="Limpiar"
                          cancelLabel="Cancelar"
                          KeyboardButtonProps={{
                            "aria-label": "change date",
                          }}
                          value={
                            moment(formValues.fecha).isValid()
                              ? moment(formValues.fecha)
                              : moment().format()
                          }
                          onChange={(date) => {
                            setearValor("fecha", date);
                          }}
                        />
                      </MuiPickersUtilsProvider>
                    </Grid>
                  )
                }
                {
                  (estado === "NOTIFICACION SOLICITUD" || estado === "RECHAZAR SOLICITUD") && (
                    <Grid item xs={7}>
                      <TextValidator
                        variant="outlined"
                        margin='normal'
                        fullWidth
                        label="Observaciones"
                        multiline
                        autoComplete="off"
                        name="observaciones"
                        value={formValues.observaciones}
                        onChange={handleInputChange}
                        InputLabelProps={{ style: { fontWeight: 'bold' } }}
                      />
                    </Grid>
                  )
                }
                {
                  (estado === "APROBAR SOLICITUD") && (
                    <Grid item xs={4}>
                      <TextValidator
                        variant="outlined"
                        margin='normal'
                        fullWidth
                        label="Expediente"
                        autoComplete="off"
                        name="expediente"
                        value={formValues.expediente}
                        type="number"
                        onChange={handleInputChange}
                        InputLabelProps={{ style: { fontWeight: 'bold' } }}
                        validators={[
                          "required"
                        ]}
                        errorMessages={[
                          "Este campo es obligatorio"
                        ]}
                      />
                    </Grid>
                  )
                }
                {
                  (estado === "APROBAR SOLICITUD" || estado === "PAGAR SOLICITUD") && (
                    <Grid item xs={4} >
                      <TextValidator
                        variant="outlined"
                        margin='normal'
                        fullWidth
                        label={
                          (estado === "APROBAR SOLICITUD") ? "Importe Reconocido" : "Importe Pagado"
                        }
                        autoComplete="off"
                        name="importeReconocido"
                        type='number'
                        validators={[
                          "isNumber",
                          "required"
                        ]}
                        errorMessages={[
                          "Solo números",
                          "Este campo es obligatorio"
                        ]}
                        value={formValues.importeReconocido}
                        onChange={handleInputChange}
                        InputLabelProps={{ style: { fontWeight: 'bold' } }}
                      />
                    </Grid>
                  )
                }
              </Grid>
              <Grid style={{ textAlign: 'center', margin: '1rem' }}>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  startIcon={<Save />}
                  type='submit'
                >
                  CAMBIAR ESTADO
                </Button>
              </Grid>
            </ValidatorForm>
          </GenericModal>
        )
      }
      {
        modalTracking.open && (
          <GenericModal
            open={modalTracking.open}
            closeModal={() => {
              setModalTracking(initModalTracking);
              surge.clean.trackingSolicitud();
            }}
            title={modalTracking.title}
            gridStyle={{ textAlign: 'center', padding: '1em' }}
            maxWidth="lg"
          >
            <Grid item xs={12}>
              <TableGeneric
                ref={componentRef}
                data={surge.data.trackingSolicitud}
                align="center"
                colTitleStyle={{ fontSize: '1.2em' }}
                withoutPagination
                columns={[
                  {
                    label: 'Estado Anterior',
                    customBody: (item) => {
                      const estadoEncontrado = surge.data.estados.find(
                        (estado) => estado.id === item.estadoAnterior,
                      );
                      return (
                        <>
                          {estadoEncontrado && (
                            <IconEstado
                              useColorTable
                              texto={estadoEncontrado.letra}
                              backgroundColor={estadoEncontrado.color}
                              descripcion={estadoEncontrado.descripcion}
                            />
                          )}
                        </>
                      );
                    },
                  },
                  {
                    label: 'Estado Actual',
                    customBody: (item) => {
                      const estadoEncontrado = surge.data.estados.find(
                        (estado) => estado.id === item.estadoActual,
                      );
                      return (
                        <>
                          {estadoEncontrado && (
                            <IconEstado
                              useColorTable
                              texto={estadoEncontrado.letra}
                              backgroundColor={estadoEncontrado.color}
                              descripcion={estadoEncontrado.descripcion}
                            />
                          )}
                        </>
                      );
                    },
                  },
                  {
                    label: 'Fecha de envío',
                    customBody: (item) => item.fechaEnvio ? moment(item.fechaEnvio).format("DD/MM/YYYY") : "-"
                  },
                  {
                    label: 'Fecha de Alta',
                    customBody: (item) => moment(item.fechaAlta).format("DD/MM/YYYY")
                  },
                  {
                    label: 'Expediente',
                    customBody: (item) => item.expediente ? item.expediente : "-"
                  },
                  {
                    label: 'Importe Original',
                    id: 'importe'
                  },
                  {
                    label: 'Importe Reconocido / Pagado',
                    customBody: (item) => item.importeReconocido ? item.importeReconocido : "-"
                  },
                  {
                    label: 'Fecha de Pago',
                    customBody: (item) => item.fechaPago ? moment(item.fechaPago).format("DD/MM/YYYY") : "-"
                  },
                  {
                    label: 'Observaciones',
                    customBody: (item) => item.observaciones ?? "-"
                  }
                ]}
              />
            </Grid>
            {
              search.idEstado !== surge.data.estados.find((estado) => estado.descripcion === "Solicitudes").id && (
                <Grid item xs={12} style={{ textAlign: 'center', margin: '1rem', justifyContent: "flex-end" }}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    startIcon={<ArrowBackIos />}
                    onClick={() => {
                      surge.update.devolverUltimoEstadoSolicitud(
                        { idSolicitud: surge.data.trackingSolicitud[0].idSolicitud },
                        () => handleSearch()
                      )
                      setModalTracking(initModalTracking);
                      surge.clean.trackingSolicitud();
                    }
                    }
                  >
                    DEVOLVER AL ESTADO ANTERIOR
                  </Button>
                </Grid>
              )
            }
          </GenericModal>
        )
      }
      {
        modalEditar.open && (
          <GenericModal
            open={modalEditar.open}
            closeModal={() => setModalEditar(initModalEditar)}
            gridStyle={{ textAlign: 'center' }}
            title={modalEditar.title}
            maxWidth="md"
          >
            <SolicitudForm solicitudCargada={modalEditar.solicitud} />
          </GenericModal>
        )
      }
    </>
  )
}

export default GestionSolicitudes;
